import React, { useEffect, useState } from "react";
import "./TimeBar.css";

function TimeBar() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const timeString = currentTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const dateString = currentTime.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const dayString = currentTime.toLocaleDateString(undefined, {
    weekday: "long",
  });

  return (
    <div className="date-time-wrapper">
      <div className="date-time-bar">
        {timeString} - {dateString} - {dayString}
      </div>
    </div>
  );
}

export default TimeBar;
